import { Navigate, Outlet } from 'react-router'
import { useAppSelector } from 'universal-scripts'

export default function RequireGuest() {
  const isLoggedIn = useAppSelector((state) => !!state.user)
  if (isLoggedIn) {
    if (__SERVER__) {
      return null
    }
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
